import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";

const customRoutes = [
  { method: "GET", path: "/current", handlerName: "getCurrentPeriod" },
  { method: "GET", path: "/upcoming", handlerName: "getUpcomingPeriods" },
];

const baseService = createCrudService("payrollPeriods", customRoutes, router);

export const payrollPeriodsService = {
  ...baseService,
};

export default payrollPeriodsService;